import rdf from '@ontologies/core';
import { HexPosition } from './HexPosition';
export const createLineParser = (rdfFactory = rdf) => {
    const bnMap = {};
    // Skip the (expensive) proxy object when parsing
    const quad = rdfFactory.quad.bind(rdfFactory);
    const literal = rdfFactory.literal.bind(rdfFactory);
    const namedNode = rdfFactory.namedNode.bind(rdfFactory);
    const blankNodeF = rdfFactory.blankNode.bind(rdfFactory);
    const defaultGraph = rdfFactory.defaultGraph.bind(rdfFactory);
    const blankNode = (v) => {
        if (!bnMap[v]) {
            bnMap[v] = blankNodeF();
        }
        return bnMap[v];
    };
    const object = (v, dt, l) => {
        if (l) {
            return literal(v, l);
        }
        else if (dt === "globalId") {
            return namedNode(v);
        }
        else if (dt === "localId") {
            return blankNode(v);
        }
        return literal(v, namedNode(dt));
    };
    return (h) => quad(h[HexPosition.Subject].startsWith("_:") ? blankNode(h[HexPosition.Subject]) : namedNode(h[HexPosition.Subject]), namedNode(h[HexPosition.Predicate]), object(h[HexPosition.Value], h[HexPosition.Datatype], h[HexPosition.Language]), h[HexPosition.Graph] ? namedNode(h[HexPosition.Graph]) : defaultGraph());
};
